import PropTypes from 'prop-types';
import CertificationDetails from './CertificationDetails';
import FeaturedImageShape from '@/shapes/FeaturedImage';
import CertificationInfoPropTypes from './CertificationInfoPropTypes';

const defaultProps = {
  featuredImage: null,
  info: null,
};

const propTypes = {
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  uri: PropTypes.string.isRequired,
  featuredImage: FeaturedImageShape,
  info: CertificationInfoPropTypes,
};

export default function Certification({
  title,
  excerpt,
  uri,
  featuredImage,
  info
}) {
  return (
    <div className="flex w-full bg-white rounded-xl shadow-lg overflow-hidden">
      <CertificationDetails
        title={title}
        excerpt={excerpt}
        uri={uri}
        badge={featuredImage}
        {...info}
      />
    </div>
  );
}

Certification.defaultProps = defaultProps;
Certification.propTypes = propTypes;
